const QuestionCircle = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M9.33325 9.33315C9.33335 8.84429 9.46782 8.36486 9.72198 7.94726C9.97614 7.52966 10.3402 7.18996 10.7744 6.96528C11.2085 6.74062 11.6962 6.63962 12.1838 6.67335C12.6716 6.70706 13.1406 6.8742 13.5397 7.15648C13.9389 7.43877 14.2527 7.82534 14.4469 8.27394C14.6413 8.72255 14.7085 9.21592 14.6413 9.70015C14.5741 10.1844 14.3751 10.6408 14.0661 11.0196C13.757 11.3984 13.3497 11.6848 12.8888 11.8478C12.6287 11.9398 12.4036 12.1101 12.2444 12.3353C12.0852 12.5607 11.9997 12.8297 11.9999 13.1056V13.9998"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12.0001 17.3333C11.816 17.3333 11.6667 17.184 11.6667 17C11.6667 16.8159 11.816 16.6666 12.0001 16.6666"
        strokeWidth={stroke}
        stroke="currentColor"
      />
      <path
        d="M12 17.3333C12.1841 17.3333 12.3333 17.184 12.3333 17C12.3333 16.8159 12.1841 16.6666 12 16.6666"
        strokeWidth={stroke}
        stroke="currentColor"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47716 17.5228 2 12 2C6.47716 2 2 6.47716 2 12C2 17.5228 6.47716 22 12 22Z"
        strokeWidth={stroke}
        strokeMiterlimit="10"
        stroke="currentColor"
      />
    </svg>
  );
};

export default QuestionCircle;
